export enum Floor {
    GROUND = "GROUND",
    LOWER = "LOWER",
    UPPER = "UPPER",
    TOP = "TOP"
}

export enum FloorNumeric {
    GROUND = 1,
    LOWER = 2,
    UPPER = 3,
    TOP = 4
}
export enum Floor {
    GROUND = "GROUND",
    LOWER = "LOWER",
    UPPER = "UPPER",
    TOP = "TOP"
}

export enum FloorNumeric {
    GROUND = 1,
    LOWER = 2,
    UPPER = 3,
    TOP = 4
}
